import React from 'react';
import { Container, Title, ExpandIcon } from './styles';

const ServerName: React.FC = () => {
  return (
    <Container>
      <Title>Servidor do Igor</Title>

      <ExpandIcon />
    </Container>
  )
}

export default ServerName;